/**
 * The URL segment the MCP Tools page lives at under the Clarity section: `/clarity/settings/mcp`.
 *
 * Shared for the same reason {@link CLARITY_INTEGRATIONS_ROUTE_SEGMENT} is: the page's own route in
 * `@efficiently/client-feat-clarity-work` and the shell's user-menu link must agree on it, and
 * `type:util` is the one layer both may reach — the menu lives in the application, which cannot
 * import a `type:feat` library to read a string off it.
 *
 * Two segments rather than one, and the same `settings/` parent as Integrations: the page is a
 * settings screen and not a tab — it carries no working domain and has no entry in the
 * control-centre strip. Brain's own path is `/settings/mcp` (`MCPSettingsPage.tsx`'s breadcrumb).
 */
export const CLARITY_MCP_SETTINGS_ROUTE_SEGMENT = 'settings/mcp';
